import { SET_CHAT_INTERVAL } from '../constants';

const setChatInterval = payload => ({ type: SET_CHAT_INTERVAL, payload });

export default setChatInterval;
